export { default } from './loyalty-commission';